import { FigureElement } from "./mutations/FigureElement.js";
import { QuoteElement } from "./mutations/QuoteElement.js";
import { PreElement } from "./mutations/PreElement.js";
import { ExistingVideoHandler } from "./mutations/IFrameElement.js";

export function initializeRichtext(): void {
    FigureElement.use();
    QuoteElement.use();
    PreElement.use();
    ExistingVideoHandler.use();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeRichtext, {
        once: true,
    });
} else {
    initializeRichtext();
}
